const stories = [
  {
    image: 'https://readdy.ai/api/search-image?query=Young%20Black%20man%20in%20his%20early%20twenties%20cooking%20in%20a%20modest%20apartment%20kitchen%20with%20natural%20window%20light%2C%20candid%20documentary%20photograph%20shot%20on%2035mm%20film%20with%20subtle%20grain%2C%20genuine%20expression%20of%20concentration%2C%20cluttered%20countertop%20with%20real%20groceries%2C%20worn%20t-shirt%2C%20natural%20skin%20texture%20and%20imperfections%2C%20warm%20imperfect%20lighting%2C%20lifestyle%20street%20photography%20style%2C%20authentic%20human%20moment%20without%20posing&width=800&height=600&seq=success-story-01-v2&orientation=landscape',
    quote: 'I learned that I could build a life I was proud of. MCT showed me that my past doesn\'t define my future.',
    label: 'Former Youth, Now Living Independently',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Young%20mixed-race%20woman%20in%20her%20late%20teens%20wearing%20a%20graduation%20cap%20laughing%20genuinely%20with%20family%20members%20outdoors%2C%20candid%20documentary%20photograph%20shot%20on%2035mm%20film%20with%20visible%20grain%2C%20natural%20golden%20hour%20lighting%20with%20soft%20shadows%2C%20authentic%20emotions%20not%20posed%2C%20natural%20skin%20texture%20and%20imperfections%2C%20warm%20imperfect%20background%2C%20street%20photography%20style%2C%20real%20human%20moment%20with%20genuine%20joy&width=800&height=600&seq=success-story-02-v2&orientation=landscape',
    label: 'High School Graduate, Class of 2025',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Young%20South%20Asian%20man%20in%20his%20early%20twenties%20working%20at%20a%20retail%20cash%20register%20helping%20a%20customer%20with%20a%20genuine%20smile%2C%20candid%20documentary%20photograph%20shot%20on%2035mm%20film%20with%20natural%20grain%2C%20fluorescent%20store%20lighting%20mixed%20with%20window%20light%2C%20authentic%20workplace%20moment%2C%20natural%20skin%20texture%20and%20imperfections%2C%20worn%20uniform%20apron%2C%20real%20store%20background%20with%20shelves%2C%20street%20photography%20style%2C%20unposed%20human%20interaction&width=800&height=600&seq=success-story-03-v2&orientation=landscape',
    label: 'Employed Youth, Retail Industry',
  },
];

export default function SuccessStoriesSection() {
  return (
    <section id="stories" className="py-24 md:py-32 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16 md:mb-20">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wider label-font mb-5">
            Success Stories
          </span>
          <h2 className="heading-font text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 max-w-3xl mx-auto leading-tight">
            Real lives. <span className="italic text-primary-600">Real</span> transformations.
          </h2>
          <p className="text-foreground-600 mt-5 max-w-2xl mx-auto leading-relaxed text-base md:text-lg">
            Behind every statistic is a young person who found their turning point. Here are a few of their stories.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {stories.map((story, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={story.image}
                  alt={`Success story - ${story.label}`}
                  title={`MCT Residential Services - Youth Success Story`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/20 to-transparent"></div>
              </div>
              <div className="p-6 md:p-7">
                <blockquote className="heading-font text-lg md:text-xl text-foreground-900 leading-relaxed italic mb-4">
                  &ldquo;{story.quote}&rdquo;
                </blockquote>
                <p className="text-foreground-500 text-xs label-font uppercase tracking-wider">{story.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}